import { ValidationError, string, StringSchema } from "yup";

const supportedHubspotSearchQueries = [
  "adgroupid",
  "adid",
  "campaignid",
  "country",
  "form_source___jp",
  "gad_campaignid",
  "gad_source",
  "gbraid",
  "gclid",
  "hsa_acc",
  "hsa_ad",
  "hsa_cam",
  "hsa_grp",
  "hsa_kw",
  "hsa_mt",
  "hsa_net",
  "hsa_src",
  "hsa_tgt",
  "hsa_ver",
  "locale",
  "utm_campaign",
  "utm_content",
  "utm_medium",
  "utm_partner",
  "utm_source",
  "utm_term",
] as const;

interface Errors {
  [key: string]: string;
}

export const getValidationErrors = (err: ValidationError): Errors => {
  const validationErrors: Errors = {};

  err.inner.forEach((error) => {
    validationErrors[error.path] = error.message;
  });

  return validationErrors;
};

interface Field {
  name: string;
  value: string;
}

export const getHubspotFieldsFromSearchQuery = (query: Record<string, string | string[]>) => {
  const fields: Field[] = [];
  for (const param of supportedHubspotSearchQueries) {
    const value = query[param];

    if (value) {
      fields.push({
        name: param,
        value: typeof value === "string" ? value : value.join(";"),
      });
    }
  }
  return fields;
};

export function removeExtraneousStringsFromHubspotFormName(name?: string) {
  return name?.replace(/Quote Spec \|/i, "").replace(/\| Virgin Schemes/i, "") || "";
}

export function buildYupStringSchema(required: boolean): StringSchema<string | undefined> {
  return required ? string().required("This field is required.") : string();
}
